{
  "app": {
    "name": "Tendfolio",
    "noWorkspace": "This account has no workspace, so there is nothing to show. Accounts created from the command line skip the sign-up that builds one. Sign out and sign up in the app, or ask an administrator to attach a workspace to this account.",
    "readOnly": {
      "trialEnded": "Your free trial ended on {{date}}. Everything is still here to look at and export, but nothing can be added or changed until the workspace has a subscription.",
      "lapsed": "This workspace has no subscription. Everything is still here to look at and export, but nothing can be added or changed until it has one."
    }
  },
  "nav": {
    "receipts": "Receipts",
    "orders": "Orders",
    "reports": "Reports",
    "settings": "Settings"
  },
  "auth": {
    "email": "Email",
    "password": "Password",
    "or": "or",
    "continueWith": "Continue with {{provider}}",
    "signOut": "Sign out",
    "backToSignIn": "Back to sign in",
    "signUp": {
      "title": "Create your workspace",
      "subtitle": "Fourteen days free. No card needed to start.",
      "submit": "Create account",
      "working": "Creating your account…",
      "haveAccount": "Already have an account?"
    },
    "signIn": {
      "title": "Sign in",
      "submit": "Sign in",
      "working": "Signing in…",
      "noAccount": "New to Tendfolio?"
    },
    "verify": {
      "sentTitle": "Check your email",
      "sentBody": "We sent you a link to confirm your address. Opening it finishes setting up your workspace.",
      "keepPaper": "Keep your paper receipts. On the Starter plan we delete receipt images once you confirm them, and the Canada Revenue Agency expects you to keep supporting documents for six years.",
      "neededTitle": "Confirm your email first",
      "neededBody": "Your account exists, but we need you to open the link we emailed you before you can sign in.",
      "resend": "Send the link again",
      "resent": "Sent. Check your email.",
      "workingTitle": "Confirming your email",
      "workingBody": "One moment…",
      "failedTitle": "That link did not work",
      "failedBody": "The link may have expired or already been used. Try signing in, and we can send a new one.",
      "confirmedTitle": "Email confirmed",
      "confirmedBody": "Your address is verified. Sign in to finish setting up your workspace."
    },
    "forgot": {
      "link": "Forgot your password?",
      "title": "Reset your password",
      "subtitle": "We will email you a link to choose a new one.",
      "submit": "Email me a link",
      "working": "Sending…",
      "sentTitle": "Check your email",
      "sentBody": "If that address has an account, a reset link is on its way."
    },
    "reset": {
      "title": "Choose a new password",
      "subtitle": "Pick something you have not used elsewhere.",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "submit": "Save password",
      "working": "Saving…",
      "doneTitle": "Password saved",
      "doneBody": "You can sign in with your new password now."
    },
    "errors": {
      "emailRequired": "Enter your email address.",
      "emailInvalid": "That does not look like an email address.",
      "passwordRequired": "Enter your password.",
      "passwordTooShort": "Use at least 8 characters.",
      "passwordMismatch": "Those passwords do not match.",
      "signInFailed": "That email and password do not match an account.",
      "unexpected": "Something went wrong. Please try again."
    }
  },
  "health": {
    "title": "System status",
    "checking": "Checking the API…",
    "ok": "API is reachable",
    "error": "API is not reachable",
    "database": "Database",
    "queue": "Jobs waiting"
  },
  "common": {
    "loading": "Loading…",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved",
    "rename": "Rename",
    "cancel": "Cancel",
    "readOnly": "The workspace is read-only until it has a subscription, so nothing can be added or changed."
  },
  "billing": {
    "title": "Billing",
    "subtitle": "Your plan, and the way to pay for it, change it or cancel it.",
    "loadFailed": "Billing could not be loaded. Try again in a moment.",
    "current": "Current plan: {{plan}}",
    "status": {
      "none": "This workspace has no subscription. Choose a plan below.",
      "trial": "Your free trial runs until {{date}}. Choose a plan before then to keep adding receipts. Nothing is charged until the trial ends.",
      "trialConverts": "Your free trial runs until {{date}}, then your card is charged each month.",
      "trialEnded": "Your free trial ended on {{date}}. Everything is still here to look at and export. Choose a plan to add and change things again.",
      "renews": "Renews on {{date}}.",
      "ending": "Canceled. Your plan stays active until {{date}}, then the workspace becomes read-only. You can resume in Manage billing before then.",
      "pastDue": "Your last payment did not go through. Update your card in Manage billing to keep your plan.",
      "lapsed": "This workspace has no active subscription, so it is read-only. Choose a plan to add and change things again."
    },
    "manage": "Manage billing",
    "opening": "Opening Stripe…",
    "openFailed": "Stripe could not be opened. Try again in a moment.",
    "plans": "Plans",
    "perMonth": "{{price}} a month",
    "noPrice": "Not available yet",
    "currentBadge": "Your plan",
    "choose": "Choose {{plan}}",
    "switchInPortal": "Switch to {{plan}} in Manage billing",
    "features": {
      "receipts_one": "{{count}} receipt read a month",
      "receipts_other": "{{count}} receipt reads a month",
      "receiptsUnlimited": "Unlimited receipt reads",
      "businesses_one": "{{count}} business",
      "businesses_other": "Up to {{count}} businesses",
      "businessesUnlimited": "Unlimited businesses",
      "photosKept": "Receipt photos kept, if you choose",
      "photosDeleted": "Receipt photos deleted once confirmed: keep the paper"
    },
    "checkout": {
      "done": "Thank you. Your subscription is set up.",
      "waiting": "Payment received. Stripe is confirming it, which takes a few seconds.",
      "canceled": "Checkout was canceled. Nothing was charged."
    },
    "stripeNote": "Payments are handled by Stripe. Tendfolio never sees your card number.",
    "pending": "Moving to {{plan}} on {{date}}.",
    "booked": "Booked: starts when your current period ends. Change your mind in Manage billing.",
    "pendingPhotos": "Photos kept on {{plan}} stay until you have downloaded everything, or chosen not to.",
    "downloadEverything": "Download everything",
    "trialBanner_one": "Your free trial ends tomorrow.",
    "trialBanner_other": "Your free trial ends in {{count}} days.",
    "trialBannerToday": "Your free trial ends today.",
    "pastDueBanner": "Your last payment did not go through. Update your card to keep your plan.",
    "seePlans": "See plans",
    "fixPayment": "Update payment"
  },
  "close": {
    "title": "Close your account",
    "subtitle": "Everything in this workspace is deleted for good. This cannot be undone.",
    "whatHappens": "When you close your account:",
    "deleted": "Every receipt and its photo, every order, payment, customer, business and category is deleted, along with your sign-in, within a few minutes.",
    "billing": "Your subscription is cancelled now. Nothing more is charged, and the rest of this month is not refunded.",
    "invoices": "Stripe keeps the invoices for what you paid, which we must keep for tax purposes.",
    "paper": "Keep your paper receipts: the CRA can ask to see the originals.",
    "step1": "1. Download everything",
    "downloaded": "You downloaded everything today, so you have a copy.",
    "downloadFirst": "Download everything first, so you keep a copy of your receipts, photos and orders. A download made today counts.",
    "skip": "Close without a download. I understand I will not have a copy.",
    "step2": "2. Confirm",
    "typeEmail": "Type your email address, {{email}}, to confirm",
    "confirm": "Close my account",
    "closing": "Closing…",
    "failed": "The account could not be closed. Please try again.",
    "closed": {
      "title": "Your account is closed",
      "body": "Everything in it is being deleted, and nothing more will be charged. Thank you for using Tendfolio.",
      "again": "Start a new account"
    }
  },
  "data": {
    "title": "Your data",
    "subtitle": "Download everything in this workspace, to keep.",
    "contents": "One zip of everything: every receipt and its items, orders, payments and customers, as spreadsheet files, with the receipt photos still kept.",
    "photosKept": "Your plan keeps receipt photos, so they will all be included.",
    "photosIncluded_one": "The {{count}} receipt photo still kept is included.",
    "photosIncluded_other": "All {{count}} receipt photos still kept are included.",
    "photosDeleted": "Photos are deleted when a receipt is confirmed on your plan, so only photos of receipts not yet confirmed are included. Keep your paper receipts.",
    "make": "Download everything",
    "making": "Making it now. With photos this can take a few minutes.",
    "failed": "The download could not be made. Please try again.",
    "recent": "Your downloads",
    "everything": "Everything",
    "askedOn": "Asked for on {{date}}",
    "photos": {
      "title": "Receipt photos from your old plan",
      "explain_one": "Your plan no longer keeps receipt photos, and {{count}} kept on your old plan is still stored. Download everything first, so you have a copy, then delete it.",
      "explain_other": "Your plan no longer keeps receipt photos, and {{count}} kept on your old plan are still stored. Download everything first, so you have a copy, then delete them.",
      "downloadFirst": "Use Download everything below first. Once you have the file, delete them here.",
      "delete_one": "Delete {{count}} photo",
      "delete_other": "Delete {{count}} photos",
      "skip": "Delete them without downloading",
      "understand_one": "I understand this photo will be gone for good. My paper receipt is the original.",
      "understand_other": "I understand these {{count}} photos will be gone for good. My paper receipts are the originals.",
      "deleteWithout_one": "Delete {{count}} photo without a download",
      "deleteWithout_other": "Delete {{count}} photos without a download",
      "deleting_one": "{{count}} photo is being deleted.",
      "deleting_other": "{{count}} photos are being deleted.",
      "banner_one": "{{count}} receipt photo from your old plan is waiting: download everything, then delete it.",
      "banner_other": "{{count}} receipt photos from your old plan are waiting: download everything, then delete them."
    }
  },
  "settings": {
    "onPlan": "You are on the {{plan}} plan.",
    "workspace": {
      "title": "Workspace",
      "subtitle": "The name you see in the app, the time zone your dates are read in, and what happens to receipt photos.",
      "name": "Workspace name",
      "timezone": "Time zone",
      "currency": "Amounts are recorded in {{currency}}.",
      "photos": {
        "title": "Receipt photos",
        "keep": "Keep receipt photos after I confirm a receipt",
        "kept": "Photos stay with their receipts, so you can look at them again later.",
        "deleted": "Each photo is deleted when you confirm its receipt. Photos already kept stay. Keep your paper receipts: the CRA can ask to see them.",
        "notOnPlan": "On the {{plan}} plan, each photo is deleted when you confirm its receipt. Keep your paper receipts: the CRA can ask to see them. Upgrading lets you keep the photos instead.",
        "readOnly": "Receipts cannot be confirmed while the workspace is read-only. Photos kept so far stay with their receipts."
      }
    },
    "businesses": {
      "title": "Businesses",
      "subtitle": "Each business is a bucket you can assign receipt lines to.",
      "addLabel": "Add a business",
      "addPlaceholder": "For example, Cakes by Sam",
      "add": "Add business",
      "empty": "You have no businesses yet. Add your first one below.",
      "inactive": "inactive",
      "deactivate": "Deactivate",
      "reactivate": "Reactivate",
      "nameOf": "Name of {{name}}",
      "capReached": "The {{plan}} plan includes {{cap}} businesses, and you have them all. Upgrade to add more."
    },
    "categories": {
      "title": "Categories",
      "subtitle": "Optional labels for spending, kept separately for each business and the household.",
      "bucket": "Show categories for",
      "household": "Household",
      "addLabel": "Add a category",
      "addPlaceholder": "For example, Packaging",
      "add": "Add category",
      "empty": "This bucket has no categories.",
      "nameOf": "Name of {{name}}",
      "deleteOf": "Delete {{name}}"
    },
    "errors": {
      "nameRequired": "Enter a name.",
      "saveFailed": "That could not be saved. Please try again.",
      "loadFailed": "That could not be loaded. Check your connection and try again."
    }
  },
  "catalog": {
    "nameOf": "Name of {{name}}",
    "merge": "Merge into…",
    "mergeInto": "Merge {{name}} into",
    "chooseKeep": "Choose the one to keep",
    "mergeExplain": "Everything under {{name}} moves to {{into}}, and {{name}} is removed. This cannot be undone.",
    "mergeConfirm": "Merge into {{into}}",
    "stores": {
      "title": "Stores",
      "subtitle": "Where you shop. If one shop appears twice under different names, merge them.",
      "empty": "No stores yet. They appear as your receipts are read.",
      "receipts_one": "{{count}} receipt",
      "receipts_other": "{{count}} receipts"
    },
    "products": {
      "title": "Products",
      "subtitle": "What you buy, named the way you want it in reports.",
      "empty": "No products yet. Confirming a receipt names its lines.",
      "lines_one": "{{count}} line",
      "lines_other": "{{count}} lines"
    },
    "remembered": {
      "subtitle": "What this store's receipts print, and the product each line is. Learned when you confirm a receipt, and applied to the next one.",
      "empty": "Nothing learned here yet. Confirm a receipt from this store to start.",
      "forget": "Forget",
      "forgetOf": "Forget what {{name}} is printed as"
    }
  },
  "orders": {
    "title": "Orders",
    "add": "New",
    "all": "All",
    "empty": "No orders yet. Tap New when a customer asks for something.",
    "noneWithStatus": "No orders here.",
    "loadMore": "Show older orders",
    "due": "Due {{date}}",
    "quote": "Quote",
    "details": "Details",
    "edit": "Edit",
    "keep": "Keep it",
    "itemLine": "{{quantity}} × {{description}}",
    "status": {
      "draft": "Draft",
      "confirmed": "Confirmed",
      "in_progress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "refunded": "Refunded"
    },
    "move": {
      "confirmed": "Confirm the order",
      "in_progress": "Start work",
      "completed": "Mark completed",
      "cancelled": "Cancel the order"
    },
    "cancelExplain": "A cancelled order cannot be reopened. A deposit can still be given back afterwards.",
    "cancelConfirm": "Cancel it",
    "money": {
      "paid": "Paid",
      "balance": "Still owed",
      "cost": "Cost",
      "margin": "Margin"
    },
    "payments": {
      "title": "Payments",
      "none": "Nothing paid yet.",
      "received": "Received by {{method}}",
      "givenBack": "Given back by {{method}}",
      "add": "Record a payment",
      "giveBack": "Give money back",
      "directionIn": "Received",
      "directionOut": "Given back",
      "method": "Method",
      "chooseMethod": "How was it paid?",
      "amount": "Amount ({{currency}})",
      "date": "Date",
      "note": "Note",
      "save": "Save payment",
      "remove": "Remove",
      "removeConfirm": "Remove this payment?"
    },
    "refund": {
      "start": "Refund",
      "explain": "The money goes back to the customer, and the order becomes refunded.",
      "save": "Refund"
    },
    "purchases": {
      "title": "What was bought for it",
      "none": "No receipt lines are attached to this order yet.",
      "inReview": "Counts toward the cost once its receipt is confirmed."
    },
    "new": {
      "title": "New order",
      "needsBusiness": "Add a business in Settings first: an order belongs to one.",
      "business": "Business",
      "chooseBusiness": "Choose a business",
      "customer": "Customer",
      "newCustomer": "A new customer…",
      "customerName": "Customer's name",
      "description": "What they ordered",
      "descriptionPlaceholder": "For example, wedding cake",
      "dueDate": "Due",
      "quote": "Quote ({{currency}})",
      "items": "Items",
      "itemDescription": "Item",
      "quantity": "Quantity",
      "unitPrice": "Price each",
      "addItem": "Add an item",
      "removeItem": "Remove this item",
      "notes": "Notes",
      "save": "Save order"
    },
    "customers": {
      "title": "Customers",
      "empty": "No customers yet. They are added here or with a new order.",
      "add": "Add a customer",
      "name": "Name",
      "phone": "Phone",
      "email": "Email"
    },
    "errors": {
      "loadFailed": "Orders could not be loaded. Check your connection and try again.",
      "saveFailed": "That could not be saved. Please try again.",
      "businessRequired": "Choose the business.",
      "customerRequired": "Choose a customer or name a new one.",
      "nameRequired": "Enter a name.",
      "emailInvalid": "Enter an email address, or leave it empty.",
      "descriptionRequired": "Say what it is.",
      "quantityInvalid": "Enter a quantity, such as 2 or 1.5.",
      "amountInvalid": "Enter an amount, such as 45.00.",
      "amountPositive": "Enter an amount above zero.",
      "methodRequired": "Choose how it was paid.",
      "dateRequired": "Enter the date.",
      "tooLong": "That is too long."
    }
  },
  "reports": {
    "title": "Reports",
    "kinds": {
      "expenses": "Expenses",
      "income": "Income",
      "orders": "Orders",
      "tax": "Sales tax",
      "household": "Household"
    },
    "groupBy": "Group by",
    "by": {
      "bucket": "Bucket",
      "category": "Category",
      "store": "Store",
      "product": "Product",
      "customer": "Customer",
      "status": "Order status",
      "method": "Payment method"
    },
    "business": "Business",
    "everyBucket": "Everything",
    "everyBusiness": "All businesses",
    "period": "Period",
    "periods": {
      "this-month": "This month",
      "last-month": "Last month",
      "this-year": "This year",
      "last-year": "Last year",
      "all": "All time",
      "custom": "Choose dates…"
    },
    "from": "From",
    "to": "To",
    "loadFailed": "The report could not be loaded. Check your connection and try again.",
    "empty": "Nothing in this period.",
    "undated_one": "1 confirmed receipt has no date, so a date range cannot include it. Add its date to count it.",
    "undated_other": "{{count}} confirmed receipts have no date, so a date range cannot include them. Add their dates to count them.",
    "missing": {
      "category": "No category",
      "store": "Unknown store",
      "product": "Not named"
    },
    "lines_one": "1 item",
    "lines_other": "{{count}} items",
    "payments_one": "1 payment",
    "payments_other": "{{count}} payments",
    "receipts_one": "1 receipt",
    "receipts_other": "{{count}} receipts",
    "total": "Total",
    "beforeTax": "Amounts are before tax, which has its own report. Only confirmed receipts count.",
    "received": "Received",
    "givenBack": "Given back",
    "net": "Net",
    "paid": "Paid",
    "cost": "Cost",
    "margin": "Margin",
    "ordersNote": "Orders created in this period, with all their money. Cost counts confirmed receipts only.",
    "sharedPart": "plus on shared receipts",
    "sharedTotal": "On shared receipts",
    "sharedExplained": "Some receipts were split between this business and others. Their tax is shown in full, on its own line, because the receipt does not say which items it was charged on.",
    "export": {
      "link": "Export",
      "title": "Export for your accountant",
      "subtitle": "One business's receipts, items, orders and payments for a period, as spreadsheet files.",
      "chooseBusiness": "Choose a business…",
      "needsBusiness": "Add a business under Settings first. An export is made for one business.",
      "make": "Make the export",
      "recent": "Recent exports",
      "making": "Making it now. This takes a few seconds.",
      "download": "Download",
      "keptUntil": "Kept until {{date}}, then deleted. Make another whenever you need it.",
      "expired": "This file has been deleted. Make a new export to get the same figures.",
      "contents": "Each download is a zip of four CSV files that open in Excel, Numbers or Google Sheets: receipts, receipt items, orders and payments. Only this business's items are included; household purchases are not.",
      "between": "{{start}} to {{end}}",
      "since": "From {{date}}",
      "until": "Up to {{date}}",
      "errors": {
        "businessRequired": "Choose a business.",
        "dateRequired": "Enter a date.",
        "backwards": "The end comes before the start.",
        "failed": "The export could not be made. Please try again.",
        "loadFailed": "Exports could not be loaded. Check your connection and try again."
      }
    }
  },
  "receipts": {
    "title": "Receipts",
    "add": "Add",
    "empty": "No receipts yet. Tap Add to photograph your first one.",
    "loadMore": "Show older receipts",
    "unknownStore": "Unknown store",
    "noDate": "No date",
    "status": {
      "uploaded": "Uploading",
      "extracting": "Reading",
      "needs_review": "To review",
      "confirmed": "Confirmed",
      "extraction_failed": "Not read"
    },
    "capture": {
      "title": "Add a receipt",
      "subtitle": "Photograph a paper receipt, or choose a screenshot or saved image.",
      "takePhoto": "Take a photo",
      "chooseImage": "Choose an image",
      "enterManually": "Enter it by hand",
      "uploading": "Uploading… {{percent}}%",
      "finishing": "Uploaded. Starting to read it…",
      "uploadFailed": "The image did not upload. Check your connection and try again.",
      "unsupported": "That file is not an image we can read. Try a JPEG, PNG or HEIC photo.",
      "failed": "Something went wrong. Please try again.",
      "capReached": "You have used all {{cap}} receipt reads on your plan this month. You can still enter receipts by hand, which never counts toward that limit, or upgrade for more."
    },
    "detail": {
      "extracting": "Reading your receipt…",
      "slow": "This is taking longer than usual. You can leave this page; the receipt will be ready when you come back.",
      "subtotal": "Subtotal",
      "total": "Total",
      "showImage": "Show the photo",
      "imageFailed": "The photo could not be loaded.",
      "imageAlt": "Photo of the receipt"
    },
    "review": {
      "editDetails": "Edit details",
      "address": "Address",
      "addTax": "Add a tax",
      "removeTax": "Remove this tax",
      "lines": "Items",
      "assignRest_one": "Put the item without a bucket in:",
      "assignRest_other": "Put the {{count}} items without a bucket in:",
      "business": "Business",
      "chooseBusiness": "A business…",
      "category": "Category",
      "noCategory": "No category",
      "remembered": "Named from an earlier receipt at this store",
      "unnamed": "Unnamed item",
      "merge": "Merge items",
      "mergeSelected_one": "Merge {{count}} item",
      "mergeSelected_other": "Merge {{count}} items",
      "selectLine": "Merge {{name}}",
      "split": "Split",
      "splitAmount": "Amount of the new item",
      "removeLine": "Remove",
      "addLine": "Add an item",
      "linesTotal": "Items",
      "mismatch": "The items and tax do not make the total. Check them against the paper, or confirm anyway if the receipt itself does not add up.",
      "noLines": "Add at least one item, so the money has a business or the household to go to.",
      "unassigned_one": "1 item still needs a business or Household.",
      "unassigned_other": "{{count}} items still need a business or Household.",
      "keepPaper": "Keep the paper receipt: the CRA can ask to see it.",
      "keepPaperDeleted": "The photo is deleted when you confirm. Keep the paper receipt: the CRA can ask to see it.",
      "confirm": "Confirm",
      "confirmAnyway": "Confirm anyway",
      "notSaved": "That change was not saved. What you see now is what was saved.",
      "notSavedBecause": "That change was not saved: {{reason}}",
      "failedEnterBelow": "We could not read this receipt. Enter its items below, with the photo to check against.",
      "startOver": "Or start over and enter it by hand",
      "reopen": "Reopen to correct",
      "imageDeleted": "The photo was deleted when this receipt was confirmed. Correct it from the paper."
    },
    "orders": {
      "attach": "Attach to an order",
      "change": "Change orders",
      "for": "For {{order}} · {{customer}}",
      "title": "Which orders was this bought for?",
      "none": "This business has no orders yet.",
      "newOrder": "Add an order",
      "share": "Share for {{order}}",
      "equalShare": "Split equally",
      "setShare": "Set by you",
      "tooMuch": "The amounts come to more than this item cost.",
      "left": "{{amount}} of this item stays with no order."
    },
    "manual": {
      "title": "Enter a receipt",
      "subtitle": "Only the total is required. Add items if you will want to split this purchase later.",
      "store": "Store",
      "storePlaceholder": "For example, Farmers market",
      "date": "Date",
      "total": "Total ({{currency}})",
      "taxLabel": "Tax",
      "taxAmount": "Tax amount",
      "optional": "Optional",
      "lines": "Items",
      "lineDescription": "What it was",
      "lineAmount": "Amount",
      "addLine": "Add an item",
      "removeLine": "Remove this item",
      "notes": "Notes",
      "save": "Save receipt"
    },
    "errors": {
      "loadFailed": "Receipts could not be loaded. Check your connection and try again.",
      "saveFailed": "That could not be saved. Please try again.",
      "totalRequired": "Enter the total.",
      "amountInvalid": "Enter an amount, such as 12.99.",
      "descriptionRequired": "Say what this item was, or remove it.",
      "tooLong": "That is too long.",
      "taxLabelRequired": "Name the tax, such as GST.",
      "taxInvalid": "Each tax needs a name and an amount."
    }
  }
}
